export const profileQuery = `query getMyProfile ($companyId: ID!, $email: String) {
      companyProfile  (id: $companyId) {
        companyName
        id
        companyId
        isMarketingReady
        productType
        name
        coverImageUrl
        marketSegments
        marketServed
        companyTypes
        website
        phone
        profileImageUrl
        imageUrls
        media {
          url
          mediaType
          created_at
          name
          size
          storageProvider
          username
          password
          tags
        }
        profileViews {
          timeViewed
          profileImageUrl
          companyId
          companyName
        }
        address {
          addressOne
          addressTwo
          city
          state
          country
          postalCode
          formattedAddress
        }
        quickResponder
        onBoardingStatus
        destinationsSold
        corporateIdentifier
        type
        description
        acctCreationReason
        contacts (email: $email) {
          firstName
          lastName
          name
          type
          phone
          fax
          email
        }
        groups {
          _id
          tag
          items
        }
        locations {
          name
          id
          city
          state
          country
          images
          isMarketingReady
          numOfProducts
          updatedAt
          products {
            name
            id
            updatedAt
          }
        }
        companyBadges {
          membershipId
          verifiedStatus
          name
          badgeId
          logo
          companyBadgeId
          acronym
          website
        }
        isLocationMarketingReady
      }
    }`.replace(/ +(?= )/g, '');

export const addLocationMutation = `mutation addLocation($supplierId:ID!, $propertyName: String!, $userFirstName: String!, $userLastName: String!, $userEmail: String!, $userId: ID!) {
  addLocation (supplierId: $supplierId, propertyName: $propertyName, userFirstName: $userFirstName, userLastName: $userLastName, userEmail: $userEmail, userId: $userId) {
    locationName
    locationId
  }
}`.replace(/ +(?= )/g, '');

export const editCompanyMutation = `mutation editCompany($companyId: ID!, $update: CompanyInputType, $companyType: String!) {
  editCompany (companyId: $companyId, update: $update, companyType: $companyType) {
    isMarketingReady
    isLocationMarketingReady
  }
}`.replace(/ +(?= )/g, '');



// WEBPACK FOOTER //
// ./src/app/stores/profile/company/profile-graphql-query.js